import type { InferProps } from 'prop-types';
import type { FunctionComponent } from 'react';
import { connect } from 'react-redux';

import type { RootState } from '@store';

import Base, { type propTypes } from './base';

export const BaseRoute = connect(
  (state: RootState) => ({ auth: state.auth }),
  {},
)(Base as FunctionComponent<InferProps<typeof propTypes>>);

export default BaseRoute;
